export const DROP_OFF = "Drop-off date";
export const PICK_UP = "Pick-up date";
export const SELECT_DATES = "Select";
